import { COLORS } from "common/colors";
import { LABELS } from "common/lables";
import { COMMON_JS } from "common/scripts";
import Btn from "components/Custom/Btn";
import React, { useState } from "react";

const OrderSummaryPrint = (props: any) => {
  const { salesReturnRef } = props;
  // const [total, setTotal] = useState<any>("");

  const generateTable = () => {
    const orderItem = salesReturnRef.getSelectedRows();
    console.log("orderItem", orderItem);
    const table = [];
    //let Total = 0;
    for (let i = 0; i < orderItem.length; i++) {
      orderItem[i]["slNo"] = i + 1;
      // Total += Number(orderItem[i].total);
      const row = [];
      let cell = (
        <tr>
          <td align="center">{orderItem[i].slNo}</td>
          <td> {orderItem[i].orderNumber}</td>
          <td align="center">{orderItem[i].customerName}</td>
          <td align="center">{orderItem[i].customerMobileNumber}</td>
          <td align="center">{orderItem[i].total}</td>
        </tr>
      );
      row.push(cell);
      table.push(row);
    }

    return table;
  };

  const calculateTotal = () => {
    const table = generateTable();
    let total = 0;
    for (let i = 0; i < table.length; i++) {
      total += Number(table[i][0].props.children[4].props.children);
    }
    console.log("table", table[0][0].props.children[4].props.children);
    return total;
  };

  return (
    <div id={"returnSummary"}>
      <div style={{ height: 600 }}>
        <table border={1} cellSpacing={0} cellPadding={5} width={"100%"}>
          <tr>
            <td
              className="headingFont"
              colSpan={5}
              style={{ alignItems: "center" }}
            >
              GAJANAN SALES AGENCY
            </td>
          </tr>
          <tr>
            <td className="headingFont" colSpan={5}>
              <span>Route Name :</span>
              <span>
                G R 10 Manharpura (MON-THU),G R22 Nageshwar To Ghanteshwar new
                ring road (MON-TUE)
              </span>
            </td>
          </tr>
          <tr>
            <td className="headingFont" colSpan={5}>
              <span>Order By :</span>
              <span>7051-ANAYAT,8595-HIMANSHU VYAS</span>
            </td>
          </tr>

          <tr>
            <td className="headingFont" colSpan={5}>
              <span>Date:</span>
              <span>28/08/2023</span>
            </td>
          </tr>
          <tr>
            <td className="headingFont" align="center" width="5%">
              No.
            </td>
            <td className="headingFont">Bill No.</td>
            <td className="headingFont" align="center">
              Party Name
            </td>
            <td className="headingFont" align="center">
              Mobile No.
            </td>
            <td className="headingFont" align="center">
              Amount{" "}
            </td>
          </tr>
          <tbody>{generateTable()}</tbody>

          <tr>
            <td colSpan={4} className="headingFont" align="center">
              Total
            </td>
            <td className="headingFont" align="center">
              {calculateTotal()}
            </td>
          </tr>
        </table>
      </div>
    </div>
  );
};

export default OrderSummaryPrint;
